import React, { createContext, useContext, useReducer } from "react";

export type SearchState = {
  value: string;
  result?: any[];
};

const initialState = {
  value: "",
  result: [],
};

export const SearchContext = createContext<SearchState>(initialState);
export const SearchDispatchContext = createContext<React.Dispatch<any>>(
  () => {}
);

export enum SearchActionType {
  SET_VALUE = "SET_VALUE",
  SET_RESULT = "SET_RESULT",
  CLEAR = "CLEAR",
}

function reducer(state: SearchState, action: { type: string; payload?: any }) {
  const { type, payload } = action;
  switch (type) {
    case SearchActionType.SET_VALUE:
      return { ...state, value: payload };
    case SearchActionType.SET_RESULT:
      if (state.value) {
        return { ...state, result: payload };
      } else {
        return state;
      }
    case SearchActionType.CLEAR:
      if (JSON.stringify(initialState) === JSON.stringify(state)) return state;
      return initialState;
    default:
      throw Error(`Type [${type}] not exist!`);
  }
}

export type SearchProviderProps = {
  children: React.ReactNode;
};

function SearchProvider({ children }: SearchProviderProps) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <SearchDispatchContext.Provider value={dispatch}>
      <SearchContext.Provider value={state}>{children}</SearchContext.Provider>
    </SearchDispatchContext.Provider>
  );
}

export const useSearch = () => useContext(SearchContext);
export const useSearchDispatch = () => useContext(SearchDispatchContext);

export default SearchProvider;
